import React, { useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { useCheckRoutingInfoQueryCache } from "#/components/carrot-plans/shared/useQueryRoutingInfo"
import { AmabAfabMedicalPreference } from "#/components/carrot-plans/steps/medical-questions/medicalFlowConstants"

export default function ShowMedicalQuestionsDecisionStep(): JSX.Element {
  const routingInfo = useCheckRoutingInfoQueryCache()
  const medicalPreference = routingInfo?.amabAfabMedicalPreference
  function showMedicalQuestions(): string {
    if (medicalPreference == null) {
      return "NO"
    }
    if (medicalPreference === AmabAfabMedicalPreference.DECLINE_MEDICAL_QUESTIONS) {
      return "NO"
    }
    return "YES"
  }

  const { send } = useStateMachine()
  useEffect(() => {
    send(showMedicalQuestions())
  })
  return <></>
}
